import { ImageIcon } from '@saleshandy/design-system';
import React from 'react';
import { Images } from '../../../../../shared/app-constants';

const NoResultScreen = () => (
    <div className="no-template-found">
      <ImageIcon src={Images?.NoResultAiColumns} alt="no-template-found" />
      <div className="no-template-text">
        <div className="no-template-found-title">No Result found</div>
        <div className="no-template-found-description">
          We couldn’t find any templates.
        </div>
      </div>
    </div>
  );

export default NoResultScreen;
